import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Button from '@starbucks-web/pattern-library/lib/components/button';
import Checkbox from '@starbucks-web/pattern-library/lib/components/checkbox';
import Tooltip from '@starbucks-web/pattern-library/lib/components/tooltip';
import { sharedCallsToAction } from 'shared/app/messages/ctas';
import { showKeepMeSignedInCheckboxSelector } from '../../state/selectors/';

import messages from './messages';

export const KeepMeSignedIn = ({ fields }) => {
  const showKeepMeSignedIn = useSelector(showKeepMeSignedInCheckboxSelector);

  const { formatMessage } = useIntl();
  if (!showKeepMeSignedIn) {
    return null;
  }
  return (
    <div className="flex items-center mb3" data-e2e="keep-me-signed-in">
      <Checkbox {...fields.rememberMe.input}>
        {formatMessage(messages.checkboxLabel)}
      </Checkbox>
      &nbsp;
      <div aria-live="polite" className="relative inline-block">
        <Tooltip
          bodyText={formatMessage(messages.tooltipMessage)}
          closeButtonAriaLabel={formatMessage(sharedCallsToAction.closeLabel)}
        >
          <Button
            aria-label={`${formatMessage(sharedCallsToAction.details)}, ${formatMessage(messages.screenreaderText)}`}
            className="px0 color-greenStarbucks text-bold text-xs"
            visualStyle="textLink"
          >
            {formatMessage(sharedCallsToAction.details)}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default KeepMeSignedIn;
